import { getTranslationFor } from '@/text/translations';
import ApplicationButton from '@/components/ApplicationButton/ApplicationButton';
import styles from './PartnersHero.module.css';

export default function PartnersHero() {
  return (
    <section className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.title}>{getTranslationFor('partners.hero.title')}</h1>
        <p className={styles.paragraph}>{getTranslationFor('partners.hero.paragraph')}</p>
        <ApplicationButton className={styles.button}>
          {getTranslationFor('partners.hero.button')}
        </ApplicationButton>
      </div>
    </section>
  );
}
